// extracted by mini-css-extract-plugin
export default {"bouton_soumettre_recherche":"recherche_bouton_soumettre_recherche__+zNs3"};